function replaceMorePaymentText() {
    document.querySelectorAll('.shopify-payment-button__more-options').forEach(function (el) {
        observer.disconnect();
        el.innerText = 'КУПИ';
        observer.observe(document.body, { childList: true, subtree: true });
    });
}

const observer = new MutationObserver(replaceMorePaymentText);
replaceMorePaymentText();
observer.observe(document.body, { childList: true, subtree: true });

// // Function to add the continue shopping button
// function addContinueShoppingButton() {
// // Find the checkout button in the cart drawer
// const checkoutButton = document.querySelector('[data-cart-checkout]');

// if (checkoutButton) {
//     // Create the continue shopping button
//     const continueButton = document.createElement('button');
//     continueButton.type = 'button';
//     continueButton.className = checkoutButton.className; // Use same styling as checkout button
//     continueButton.textContent = 'Продължи пазаруването';
//     continueButton.style.marginTop = '10px'; // Add some spacing
    
//     // Add click handler to close the cart drawer
//     continueButton.addEventListener('click', function(e) {
//     e.preventDefault();
//     closeCartDrawer();
//     });
    
//     // Insert the button after the checkout button
//     checkoutButton.parentNode.insertBefore(continueButton, checkoutButton.nextSibling);
// }
// }

// // Function to close the cart drawer
// function closeCartDrawer() {
// // Try common cart drawer selectors
// const drawer = document.querySelector('[data-cart-drawer]') || 
//                 document.querySelector('.cart-drawer') ||
//                 document.querySelector('[role="dialog"][aria-label*="cart" i]');

// if (drawer) {
//     // Try to find and click the close button
//     const closeButton = drawer.querySelector('[aria-label*="close" i]') ||
//                         drawer.querySelector('.drawer-close') ||
//                         drawer.querySelector('[data-close-drawer]');
    
//     if (closeButton) {
//     closeButton.click();
//     } else {
//     // Fallback: remove the drawer or hide it
//     drawer.style.display = 'none';
//     }
// }
// }

// // Run on initial load
// addContinueShoppingButton();

// // Re-run when cart updates (for dynamic cart changes)
// document.addEventListener('cart:updated', addContinueShoppingButton);
